import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { Trans } from 'react-i18next';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import {
  WithMobileContextProps,
  withMobileContext,
} from '@wix/da-react-context/pkg/MobileContext';
import s from './ProfileStatItems.scss';

function placeCommasInNumber(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export interface Props {
  statsData: {
    [k: string]: number;
  };
  defaultStats: string[];
  additionalStats: string[];
  itemClassName?: string;
  countClassName?: string;
}

export class ProfileStatItems extends React.Component<
  Props & WithMobileContextProps
> {
  render() {
    const {
      defaultStats,
      additionalStats,
      itemClassName,
      countClassName,
      statsData,
      isMobile,
    } = this.props;
    const stats = [...defaultStats!, ...additionalStats!];

    return stats.map(stat => {
      const statValue = statsData[stat] || 0;
      const formattedCount = shortenNumber(statValue);
      const isTooltipNeeded = Number(formattedCount) !== statValue;
      return (
        <span key={stat} className={classnames(s['item'], itemClassName)}>
          <Trans i18nKey={`profileStats.${stat}`} count={statValue}>
            {!isMobile && isTooltipNeeded ? (
              <SimpleTooltip
                key={stat}
                placement="top"
                text={placeCommasInNumber(statValue)}
              >
                {formattedCount}
              </SimpleTooltip>
            ) : (
              <span className={countClassName}>{formattedCount}</span>
            )}
            &nbsp;
            {stat}
          </Trans>
        </span>
      );
    });
  }
}

const enhance = compose(withMobileContext);

export default enhance(ProfileStatItems) as React.ComponentType<Props>;
